export default __webpack_public_path__ + "static/media/timpers.b7847364.png";